import { useState, useMemo } from 'react';

import { textArr } from './constants';
import styles from './style.module.scss';

const World = () => {
  const [type, setType] = useState(0);
  const [subType, setSubType] = useState(0);

  const prevIndex = useMemo(() => {
    if (subType === 0) return 4;
    if (subType === 5) return 9;
    return subType - 1;
  }, [subType]);

  const nextIndex = useMemo(() => {
    if (subType === 4) return 0;
    if (subType === 9) return 5;
    return subType + 1;
  }, [subType]);

  return (
    <div className={styles.container}>
      {/* 类型按钮 */}
      <div className={styles.typeBtns}>
        <div
          className={`${styles.inBtn} ${type === 0 ? styles.active : ''}`}
          onClick={() => { setType(0); setSubType(0); }}
        />
        <div
          className={`${styles.infoBtn} ${type === 1 ? styles.active : ''}`}
          onClick={() => { setType(1); setSubType(5); }}
        />
      </div>
      {/* 主体部分 */}
      <div className={styles.core}>
        {/* 子类型切换按钮 */}
        <div
          className={`${styles.prevBtn} ${styles[`subBtn${prevIndex}`]}`}
          onClick={() => { setSubType(prevIndex); }}
        />
        <div
          className={`${styles.nextBtn} ${styles[`subBtn${nextIndex}`]}`}
          onClick={() => { setSubType(nextIndex); }}
        />
        <div className={styles.rotateCircle} />
        {textArr.map((item, index) => (
          <div
            key={index}
            className={`${styles.text} ${subType === index ? styles.active : ''}`}
            dangerouslySetInnerHTML={{
              __html: item,
            }}
          />
        ))}
      </div>
      {/* 子类型列表 */}
      <div className={styles.subTypeList}>
        <div className={styles.dash} />
        {type === 0 && (
        <ul>
          <li
            className={`${subType === 0 ? styles.active : ''}`}
            onClick={() => { setSubType(0); }}
          >
            <span className={styles.iconRect} />
            踏入世界
          </li>
          <li
            className={`${subType === 1 ? styles.active : ''}`}
            onClick={() => { setSubType(1); }}
          >
            <span className={styles.iconRect} />
            西月之国
          </li>
          <li
            className={`${subType === 2 ? styles.active : ''}`}
            onClick={() => { setSubType(2); }}
          >
            <span className={styles.iconRect} />
            长梦之坠
          </li>
          <li
            className={`${subType === 3 ? styles.active : ''}`}
            onClick={() => { setSubType(3); }}
          >
            <span className={styles.iconRect} />
            魔渊之战
          </li>
          <li
            className={`${subType === 4 ? styles.active : ''}`}
            onClick={() => { setSubType(4); }}
          >
            <span className={styles.iconRect} />
            羁绊之约
          </li>
        </ul>)}
        {type === 1 && (
        <ul>
          <li
            className={`${subType === 5 ? styles.active : ''}`}
            onClick={() => { setSubType(5); }}
          >
            <span className={styles.iconRect} />
            隐
          </li>
          <li
            className={`${subType === 6 ? styles.active : ''}`}
            onClick={() => { setSubType(6); }}
          >
            <span className={styles.iconRect} />
            魔
          </li>
          <li
            className={`${subType === 7 ? styles.active : ''}`}
            onClick={() => { setSubType(7); }}
          >
            <span className={styles.iconRect} />
            妖
          </li>
          <li
            className={`${subType === 8 ? styles.active : ''}`}
            onClick={() => { setSubType(8); }}
          >
            <span className={styles.iconRect} />
            掠影者
          </li>
          <li
            className={`${subType === 9 ? styles.active : ''}`}
            onClick={() => { setSubType(9); }}
          >
            <span className={styles.iconRect} />
            隐石
          </li>
        </ul>)}
      </div>
    </div>
  );
};

export default World;
